import { RecoverPassword } from '@/config/types';
import { apiLoginGA } from '@/services/api-config';

export default async function (payload: RecoverPassword) {
  return apiLoginGA
    .post('password/recover', payload)
    .then((response) => response.data)
    .catch((e) => e.response.data);
}
